<template>
  <div class="public_bg">
    <div class="complete-bod">
      <!-- 左侧 -->
      <div class="ban-left float-le mt-5">
        <p class="banl-p2"><span>普惠均等 便捷高效 精准智能</span></p>
        <!-- 表单提交 -->
        <form class="form" action="">
          <input type="text" class="form-control" @keyup.enter="search" v-model="keyword" placeholder="请输入查询应用或关键词">
<input type="hidden">
          <button type="submit" class="input-group-addon btn btn-danger"  @click="search"><a-icon type="search" /></button>
        </form>
      </div>
      <!-- 右侧 -->
      <div class="ban-right float-rig">
        <!--<ul class="fl left">
          <li><a-icon type="solution" /><a>统一身份认证</a></li>
          <li><a-icon type="idcard" /><a>统一证照服务</a></li>
          <li><a-icon type="schedule" /><a>统一事项服务</a></li>
          <li><a-icon type="audit" /><a>统一法律服务</a></li>
          <li><a-icon type="form" /><a>统一投诉建议</a></li>
          <li><a-icon type="snippets" /><a>统一满意度评价</a></li>
          <li><a-icon type="file-done" /><a>统一用户服务</a></li>
          <li><a-icon type="file-search" /><a>统一搜索服务</a></li>
        </ul>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Commonbanner',
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    search () {
      if (this.keyword.length > 0) {
        this.$router.push('/search?type=1&keyword=' + encodeURI(this.keyword))
      } else {
      }
    }
  }
}
</script>
